import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import logo from '../../../assets/damelio_logo_blanco.png';
import logoText from '../../../assets/damelio_texto_blanco.png';
import { scrollToTop } from '../../../lib/scrollToTop';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-gray-400 pt-12 pb-6 w-full relative z-20 mt-12">
      <div className="max-w-6xl mx-auto px-6">

        {/* Contenido en columnas */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-sm mb-10">

          {/* Columna 1: Recursos */}
          <div>
            <h4 className="text-white font-semibold mb-3">{t('footer.resourcesTitle')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/dashboard"  onClick={scrollToTop} className="hover:text-white transition">
                  {t('footer.dashboard')}
                </Link>
              </li>
              <li>
                <Link to="/documentation" onClick={scrollToTop} className="hover:text-white transition">
                  {t('footer.documentation')}
                </Link>
              </li>
              <li>
                <Link to="/faq" onClick={scrollToTop} className="hover:text-white transition">
                  {t('footer.faq')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna 2: Partners */}
          <div>
            <h4 className="text-white font-semibold mb-3">{t('footer.partnersTitle')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/partners" onClick={scrollToTop} className="hover:text-white transition">
                  {t('footer.partnersLink')}
                </Link>
              </li>
              <li>
                <a href="mailto:partners@damelio.io" className="hover:text-white transition">
                  partners@damelio.io
                </a>
              </li>
            </ul>
          </div>

          {/* Columna 3: Información legal */}
          <div>
            <h4 className="text-white font-semibold mb-3">{t('footer.infoTitle')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" onClick={scrollToTop} className="hover:text-white transition">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/cookies-policy" onClick={scrollToTop} className="hover:text-white transition">
                  {t('footer.cookies')}
                </Link>
              </li>
              <li>
                <Link to="/legal-notice" onClick={scrollToTop} className="hover:text-white transition">
                  {t('footer.legal')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna 4: Logo */}
          <div className="flex items-start md:justify-end justify-center">
            <Link to="/" onClick={scrollToTop} className="flex items-center space-x-3">
              <img src={logo} alt="Damelio Logo" className="h-16 w-16 object-contain" />
              <img src={logoText} alt="Damelio Texto" className="h-10 object-contain" />
            </Link>
          </div>
        </div>

        {/* Derechos */}
        <div className="text-center text-xs text-gray-500">
          © 2026 <span className="text-white font-semibold">Damelio</span>. {t('footer.rights')}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
